import { exp } from "./core/plugins/TitleRibbon/plugins/EasyModal";
import router from "./router";
import Vue from "vue";
import { ir } from "./check_domain_ir";

function handleError(request, settings) {
  if (request.status === 404 && request.responseJSON.message !== "") {
    exp.error("خطا!", request.responseJSON.message);
    throw new Error(request.statusText);
  } else exp.error("خطا!", "درخواست شما معتبر نیست.");

  if (request.status === 422) {
    let Extra = [];

    Object.keys(request.responseJSON.errors).forEach((key) => {
      try {
        settings.component.$refs[key].errorMessages =
          request.responseJSON.errors[key][0];
      } catch (e) {
        Extra.push(key);
      }
    });

    let errors = Extra.map((item) => {
      return request.responseJSON.errors[item].join("\n");
    });

    exp.error("خطا!", "لطفا اطلاعات را به درستی وارد کنید.", errors.join("\n"));
    throw new Error(request.statusText);
  }

  if (request.status === 400) {
    return;
  }

  exp.error(
    "خطا!",
    request.responseJSON.code ||
      request.responseJSON.errors[0] ||
      request.responseJSON.message
  );
}

// $(document).ajaxSend(function (event, request, settings) {
//     if (settings.url.indexOf("page") <= -1 && settings.url.indexOf('api/admin/users?') <= -1)
//         exp.showLoading();
// });

$(document).ajaxSuccess(function (event, request, settings) {
  let extra = [];
  exp.hideLoading();
  exp.hideConnectionLost();

  const routes = {
    "/sendADS/taki": [
      {
        text: "درج آگهی جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج آگهی درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست آگهی ها",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/myAdsList");
        },
      },
    ],
    "/sendADS/multi": [
      {
        text: "درج آگهی جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج آگهی درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست آگهی ها",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/myAdsList");
        },
      },
    ],
    "/Tools/defaultText": [
      {
        text: "درج پیشفرض جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج پیشفرض درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست متن پیشفرض",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/defTextList");
        },
      },
    ],
    "/sendADS/default": [
      {
        text: "درج پیشفرض جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج پیشفرض درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست آگهی پیشفرض",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/defaultList");
        },
      },
    ],
    "/sendADS/gradual": [
      {
        text: "ارسال تدریجی جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "ارسال تدریجی درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست تدریجی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/sendADS/smart": [
      {
        text: "ارسال هوشمند جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "ارسال هوشمند درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست هوشمند",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/Tools/gradualLadder": [
      {
        text: "نردبان تدریجی جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "نردبان تدریجی درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست تدریجی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/Tools/SmartLadder": [
      {
        text: "نردبان هوشمند جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "نردبان هوشمند درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست هوشمند",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/Tools/gradualShop": [
      {
        text: "نردبان تدریجی جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "نردبان تدریجی درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست تدریجی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/Numbers/rentNumber": [
      {
        text: "اجاره شماره جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/addNewNumber/add");
        },
      },
      {
        text: "مشاهده و شارژ شماره ها",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/Numbers/numberList");
        },
      },
      {
        text: "درج آگهی تکی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/sendADS/taki");
        },
      },
      {
        text: "درج آگهی گروهی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/sendADS/multi");
        },
      },
    ],
    "/Tools/uploader": [
      {
        text: "آپلود عکس جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "درج آگهی تکی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/sendADS/taki");
        },
      },
      {
        text: "درج آگهی گروهی",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/sendADS/multi");
        },
      },
    ],
    "/Tools/unrepeatAbleText": [
      {
        text: "سفارش جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "لیست متن پیشفرض",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/defTextList");
        },
      },
      {
        text: "لیست آگهی پیشفرض",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/defaultList");
        },
      },
    ],
    "/Tools/autoChats": [
      {
        text: "افزودن چت جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "مشاهده لیست چت ها",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "اجاره شماره جدید",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/addNewNumber/add");
        },
      },
    ],
    "/Tools/smartShop": [
      {
        text: "نردبان هوشمند جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "نردبان هوشمند درهمین دسته",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
      {
        text: "مشاهده لیست هوشمند",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/smartsList");
        },
      },
    ],
    "/Tools/attack": [
      {
        text: "افزودن حمله جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "اجاره شماره جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/addNewNumber/add");
        },
      },
      {
        text: "مشاهده لیست حمله ها",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/Monitoring/inAction");
        },
      },
    ],
    "/adsList/defaultList": [
      {
        text: "درج ارسال سریع جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          if (settings.reload_table) settings.reload_table();
        },
      },
      {
        text: "مشاهده لیست آگهی ها",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.push("/adsList/myAdsList");
        },
      },
    ],
    "/adsList/myAdsList": [
      {
        text: "درج ارتقا جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج ارتقا در همین صفحه",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
    ],
    "/adsList/renewAds": [
      {
        text: "درج ارتقا جدید",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          router.go(0);
        },
      },
      {
        text: "درج ارتقا در همین صفحه",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
    ],
    "/Monitoring/payMonitoring": [
      {
        text: "رفرش صفحه",
        icon: "fa-plus",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {
          if (settings.reload_table) settings.reload_table();
        },
      },
      {
        text: "ادامه بدون رفرش",
        icon: "fa-eye",
        class: "btn btn-outline-lightGreen mx-10 my-1",
        onClick() {},
      },
    ],
  };

  const redirection = {
    "/sendADS/taki": "/adsList/myAdsList",
    "/Monitoring/market": "/adsList/smartsList",
    "/Monitoring/estates": "/adsList/myAdsList",
    "/Tools/gradualLadder": "/adsList/smartsList",
    "/Tools/SmartLadder": "/adsList/smartsList",
  };

  // routes[router.history.current.path]

  if (settings.msg) {
    exp.success(
      "درخواست شما با موفقیت انجام شد!",
      request.responseJSON ? request.responseJSON.message : "",
      undefined,
      undefined
    );
    // router.replace(redirection[router.history.current.path]);
  }
});

$(document).ajaxError(function (event, request, settings) {
  exp.hideConnectionLost();

  // if (request.status === 0 && process.env.NODE_ENV !== "production") {
  //     exp.showConnectionLost(() => {
  //         settings.fn(...(settings.params || []));
  //     });
  //     return;
  // }
  //
  // if (request.status === 0 && process.env.NODE_ENV === "production") {
  //     exp.showConnectionLost(() => {
  //         router.go(0);
  //     });
  //     return;
  // }

  if (settings.msg !== false) handleError(request, settings);
});

let timer = null;

export const debounce = function (fn, delay) {
  clearTimeout(timer);

  timer = setTimeout(fn, delay);
};
